export const wrapperStyles = {};

export const alternateNameGroupStyles = {
  gridTemplateColumns: `repeat(5, 1fr)`,
};
